// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";
import { closeSessionGlobal } from "../commons/utils";
import { QueryPagination } from "../commons/interfaces";
import { buildQuery } from "../commons/utils/helpers";


const http = new AxiosAdapter();



export const setCustomerService = async(customer:object, setPercentajeCCompany:any) => {
   
    try {
        
        return await http.post<any>('/v1/customer', customer, setPercentajeCCompany); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('tonkaaaaaaasetCustomerServiceaaaaaaaaaaa ',error)
    }
}




export const addApplicationToCustomerService = async(application:object, setPercentajeCCompany:any) => {
   
    try {
        
        return await http.post<any>('/v1/customer/add-application', application, setPercentajeCCompany); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('addApplicationToCustomerService ',error)
    }
}



export const getApplicationCustomerService = async() => {
   
    try {

        return await http.get<any>(`/v1/applications`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getApplicationCustomerService ',error)
    }
}





export const getAllCustomerNoPaginateService = async() => {
   
    try {

        return await http.get<any>(`/v1/customer`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getAllCustomerNoPaginateService ',error)
    }
}



export const getAllCustomerByParamService = async(param:number) => {
   
    try {

        return await http.get<any>(`/v1/customer/search/${param}`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('tonkaaaaaaaaaaaaaaaaaa getAllTipoNovedadService ',error)
    }
}



export const getAllCustomerService = async(query?: QueryPagination) => {
   
    try {
        return await http.get<any>(`/v1/customer?${buildQuery(query)}`); 
    } catch (error:any) {
        if( error &&  !error.ok ){
            return error;
        }
        console.log('getAllCustomerService ',error)
    }
}

export const getCustomersBySearchService = async (param: string, status: number = 1, page: number = 1) => {
    try {
        const query = status !== undefined ? `&status=${status}` : '';
        return await http.get<any>(`/v1/customer?page=${page}&take=10&param=${param}${query}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getCustomersBySearchService ', error);
    }
}



export const createTipoNovedadService = async(tipoNovedad:object, setPercentajeCreateTurno:any) => {
   
    try {

        return await http.post<any>(`/v1/type-news`, tipoNovedad, setPercentajeCreateTurno); 

    } catch (error:any) {

        if( error.code === 403 ){
            
            await closeSessionGlobal(); 
            window.location.href = '/';

        }
        console.log('createParameterService ',error)
    }
}




export const removeApplicationCustomerService = async(applicationId: string, customerId: string) => {
   
    try {

        return await http.delete<any>(`/v1/customer/customer-application/${applicationId}/${customerId}`); 

    } catch (error:any) {


        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('removeApplicationToCustomerService ',error)
    }
}




export const deleteCustomerService = async (customerId: string, query?: QueryPagination) => {
    try {
        return await http.deleteTable<any>(`/v1/customer/${customerId}?${buildQuery(query)}`); 
    } catch (error:any) {
        if( error &&  !error.ok ){
            return error;
        }
        console.log('deleteCustomerService ',error)
    }
}



export const restoreCustomerService = async (customerId: string, query?: QueryPagination) => {
    try {
        return await http.patchTable<any>(`/v1/customer/${customerId}/restore?${buildQuery(query)}`); 
    } catch (error:any) {
        if( error &&  !error.ok ){
            return error;
        }
        console.log('restoreCustomerService ',error)
    }
}



export const getDetailCustomerService = async(customerId:string) => {
   
    try {

        return await http.get<any>(`/v1/customer/${customerId}`); 

    } catch (error:any) {

        
        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('getDetailCustomerService ',error);
    }
}



export const getApplicationsPermissionsCustomerService = async(idCustomerApplication:string, customerId:string) => {
   
    try {

        return await http.get<any>(`/v1/customer-application/permissions-customer/${idCustomerApplication}/${customerId}`); 

    } catch (error:any) {

        
        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('getDetailCustomerService ',error);
    }
}



export const updateCustomerService = async(customer: object) => {
   
    try {

        return await http.put<any>(`/v1/customer`, customer); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('updateCustomerDetailService ',error);

    }
}




export const updatePermissionsCustomerService = async(permissions: object) => {
   
    try {

        return await http.put<any>(`/v1/customer/permissions`, permissions); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('updateCustomerDetailService ',error);

    }
}